module.exports = __webpack_public_path__ + "static/media/road-truck-services.d64cb8ab.jpg";